import { useCallback } from 'react';
import { hasMonthDiff } from 'js/utils/date.util';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as helpers from '../../../helpers';

export const useValidate = () => {
    const translate = useComponentTranslations();

    return useCallback(({ from: fromDate, until: untilDate }) => {
        const from = helpers.intoDate(fromDate);
        const until = helpers.intoDate(untilDate);
        const rangeError = translate('filter.error.range');
        const timePeriodError = translate('filter.error.timePeriod');

        if (from > until) {
            return { from: timePeriodError, until: timePeriodError };
        }

        if (hasMonthDiff(from, until, 3)) {
            return { from: rangeError, until: rangeError };
        }
    }, [translate]);
};
